module.exports = __webpack_public_path__ + "static/people_img5@2x-7f5f8449f1b13a2d1d1179a27fc8472c.png";